// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 806) return "static/chunks/806-b8ada319aded9a51.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + "432f664cf2180069" + ".js";
};